__turbopack_context__.v({
  "auto-complete": "_59KpMq_auto-complete",
  "button": "_59KpMq_button",
  "card": "_59KpMq_card",
  "icon": "_59KpMq_icon",
  "list": "_59KpMq_list",
  "wrapper": "_59KpMq_wrapper",
});
